import url from './url';

/**
 * Push GTM event to data layer
 *
 * @returns
 */
const pushGTMEvent = (data) =>
  window?.dataLayer?.push({
    ...data,
    source: url.isAppOnly() ? 'app' : 'web'
  });

export default {
  pushGTMEvent
};
